document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initCifras();
  initGaleriaProducto();
  initVariantesProducto();
  initMarquesina();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initCifras() {
  var els = document.querySelectorAll('[data-mt-cifra]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
      var suffix = el.getAttribute('data-mt-sufijo') || '';
      if (reduced) {
        el.textContent = target + suffix;
        return;
      }
      var start = null;
      var duracion = 1400;
      function paso(ts) {
        if (!start) start = ts;
        var progreso = Math.min((ts - start) / duracion, 1);
        var facilitado = 1 - Math.pow(1 - progreso, 3);
        var valor = target * facilitado;
        el.textContent = (Number.isInteger(target) ? Math.round(valor) : valor.toFixed(1)) + suffix;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-comparado]');
  var botonEl = form.querySelector('[data-mt-boton-comprar]');
  if (!selects.length || !idInput) return;

  function variantePorSeleccion() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = variantePorSeleccion();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = variante.precio;
    if (precioCompareEl) {
      if (variante.precioComparado) {
        precioCompareEl.textContent = variante.precioComparado;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (variante.disponible) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-texto-disponible') || botonEl.textContent;
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initMarquesina() {
  var track = document.querySelectorAll('[data-mt-marquesina]');
  if (!track.length) return;
  track.forEach(function (el) {
    if (el.getAttribute('data-mt-clonada')) return;
    el.innerHTML += el.innerHTML;
    el.setAttribute('data-mt-clonada', '1');
  });
}
